import { hotjar } from 'react-hotjar';
import { isSyntheticMonitor } from './syntheticMonitor';

const HOTJAR_SITE_ID = 878173;
const HOTJAR_SNIPPET_VERSION = 6;

function initializeHotjarSurvey(storageKey: string) {
  if (isSyntheticMonitor()) return;
  if (!sessionStorage.getItem(storageKey)) {
    console.log(
      'Hotjar survey is running on this step for storage key:',
      storageKey
    );

    loadHotjar();
    sessionStorage.setItem(storageKey, 'true');
  }
}

function loadHotjar() {
  if (isSyntheticMonitor() || hotjar.initialized()) return;
  hotjar.initialize({ id: HOTJAR_SITE_ID, sv: HOTJAR_SNIPPET_VERSION });
}

export { initializeHotjarSurvey, loadHotjar };
